<template>
  <div id="contact">
    <app-menu></app-menu>
    <admin-list-component
        title="Kontakty"
        add-text="Přidat kontakt"
        edit-path="/admin/contact/edit/"
        entity-name="contact"
        :get-name-function="getName"
        draggable="true"
    />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import AdminListComponent from "@/components/admin/AdminListComponent";

export default {
  name: "contact",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  methods: {
    getName: function (contact) {
      return contact.name;
    }
  }
}
</script>

<style scoped>
#contact {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
}

hr {

}
</style>
